import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, Injector, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { variables } from 'libs/shared/utils/variables/variables';

@Injectable({
  providedIn: 'root',
})
export class SiteLanguageService {
  private injector = inject(Injector);
  private _translateService: TranslateService | null = null;

  private get translateService(): TranslateService {
    if (!this._translateService) {
      this._translateService = this.injector.get(TranslateService);
    }
    return this._translateService;
  }

  platformId = inject(PLATFORM_ID);

  lang_iso = variables.defaultLanguage;
  lang_id = 71;
  lang_name: any;

  actualSiteLanguageId() {
    // Use a try-catch to handle potential circular dependency issues
    try {
      this.lang_iso =
        this.translateService?.currentLang ??
        (!isPlatformServer(this.platformId)
          ? localStorage.getItem(variables.languageCodeStorageKey)
          : 'en');
    } catch (e) {
      this.lang_iso = 'en';
    }

    switch (this.lang_iso) {
      case 'af': //Afrikaans
        this.lang_id = 5;
        break;
      case 'ar': //Arabic
        this.lang_id = 13;
        break;
      case 'az': //Azerbaijani
        this.lang_id = 22;
        break;
      case 'bg': //Bulgarian
        this.lang_id = 38;
        break;
      case 'bs': //Bosnian
        this.lang_id = 36;
        break;
      case 'ca': //Catalan
        this.lang_id = 41;
        break;
      case 'cs': //Czech
        this.lang_id = 62;
        break;
      case 'cy': //Welsh
        this.lang_id = 290;
        break;
      case 'da': //Danish
        this.lang_id = 64;
        break;
      case 'de': //German
        this.lang_id = 88;
        break;
      case 'dv': //Divehi; Dhivehi; Maldivian
        this.lang_id = 66;
        break;
      case 'el': //Greek
        this.lang_id = 89;
        break;
      case 'en': //English
        this.lang_id = 71;
        break;
      case 'es': //Spanish
        this.lang_id = 247;
        break;
      case 'et': //Estonian
        this.lang_id = 73;
        break;
      case 'eu': //Basque
        this.lang_id = 27;
        break;
      case 'fa': //Persian
        this.lang_id = 210;
        break;
      case 'fi': //Finnish
        this.lang_id = 78;
        break;
      case 'fr': //French
        this.lang_id = 79;
        break;
      case 'gl': //Galician
        this.lang_id = 85;
        break;
      case 'hr': //Croatian
        this.lang_id = 61;
        break;
      case 'hu': //Hungarian
        this.lang_id = 104;
        break;
      case 'hy': //Armenian
        this.lang_id = 15;
        break;
      case 'id': //Indonesian
        this.lang_id = 109;
        break;
      case 'is': //Icelandic
        this.lang_id = 105;
        break;
      case 'it': //Italian
        this.lang_id = 114;
        break;
      case 'ja': //Japanese
        this.lang_id = 116;
        break;
      case 'jv': //Javanese
        this.lang_id = 117;
        break;
      case 'ko': //Korean
        this.lang_id = 132;
        break;
      case 'ky': //Kirghiz; Kyrgyz
        this.lang_id = 140;
        break;
      case 'lt': //Lithuanian
        this.lang_id = 152;
        break;
      case 'lv': //Latvian
        this.lang_id = 146;
        break;
      case 'nl': //Dutch; Flemish
        this.lang_id = 69;
        break;
      case 'no': //Norwegian
        this.lang_id = 195;
        break;
      case 'pl': //Polish
        this.lang_id = 211;
        break;
      case 'pt': //Portuguese
        this.lang_id = 212;
        break;
      case 'ro': //Romanian
        this.lang_id = 220;
        break;
      case 'rs': //???? Serbian
        this.lang_id = 234;
        break;
      case 'ru': //Russian
        this.lang_id = 223;
        break;
      case 'rw': //Kinyarwanda
        this.lang_id = 128;
        break;
      case 'si': //	Sinhala; Sinhalese
        this.lang_id = 240;
        break;
      case 'sk': //	Slovak
        this.lang_id = 242;
        break;
      case 'sl': //	Slovenian
        this.lang_id = 243;
        break;
      case 'sr': //	Serbian
        this.lang_id = 234;
        break;
      case 'sv': //	Swedish
        this.lang_id = 252;
        break;
      case 'th': //	Thai
        this.lang_id = 265;
        break;
      case 'tr': //	Turkish
        this.lang_id = 276;
        break;
      case 'uk': //	Ukrainian
        this.lang_id = 281;
        break;
      case 'uz': //	Uzbek
        this.lang_id = 284;
        break;
      case 'vi': //	Vietnamese
        this.lang_id = 287;
        break;
      case 'zh-cn': //	Chinese - Simplified
        this.lang_id = 51;
        break;
      case 'zh': //	Chinese - Simplified
        this.lang_id = 51;
        break;
      case 'zh-tw': //	Chinese - Traditional
        this.lang_id = 52;
        break;
      case 'ps': //	Pashto
        this.lang_id = 209;
        break;
      case 'sq': //	Albanian
        this.lang_id = 8;
        break;
      case 'be': //	Belarusian
        this.lang_id = 29;
        break;
      case 'km': //	Khmer
        this.lang_id = 126;
        break;
      case 'am': //	Amharic
        this.lang_id = 9;
        break;
      case 'ur': //	Urdu
        this.lang_id = 282;
        break;
      case 'ka': //	Georgian
        this.lang_id = 87;
        break;
      case 'he': //	Hebrew
        this.lang_id = 97;
        break;
      case 'kk': //	Kazakh
        this.lang_id = 125;
        break;
      case 'sw': //	Swahili
        this.lang_id = 250;
        break;
      case 'lo': //	Lao
        this.lang_id = 144;
        break;
      case 'mk': //	Macedonian
        this.lang_id = 160;
        break;
      case 'mn': //	Mongolian
        this.lang_id = 180;
        break;
      case 'ne': //	Nepali
        this.lang_id = 189;
        break;
      case 'ta': //	Tamil
        this.lang_id = 261;
        break;
      case 'tg': //	Tajik
        this.lang_id = 259;
        break;

      case 'tk': //	Turkmen
        this.lang_id = 277;
        break;
      case 'my': //	Burmese
        this.lang_id = 39;
        break;

      case 'ti': //	Tigrinya
        this.lang_id = 267;
        break;

      case 'mt': //	Maltese
        this.lang_id = 167;
        break;
      case 'sm': //	Samoan
        this.lang_id = 226;
        break;
      default: {
        this.lang_id = 71;
      }
    }

    return this.lang_id;
  }

  actualSiteLanguageIso() {
    let lang_iso = 'en';

    try {
      lang_iso =
        this.translateService?.currentLang ??
        (!isPlatformServer(this.platformId)
          ? localStorage.getItem(variables.languageCodeStorageKey)
          : 'en');
    } catch (e) {
      lang_iso = 'en';
    }

    return lang_iso;
  }
  actualSiteName() {
    this.lang_iso =
      this.translateService.currentLang ??
      (!isPlatformServer(this.platformId)
        ? localStorage.getItem(variables.languageCodeStorageKey)
        : 'en');

    switch (this.lang_iso) {
      case 'af': // 5
        this.lang_name = 'Afrikaans';
        break;
      case 'ar': // 13
        this.lang_name = 'Arabic';
        break;
      case 'az': // 22
        this.lang_name = 'Azerbaijani';
        break;
      case 'bg': // 38
        this.lang_name = 'Bulgarian';
        break;
      case 'bs': // 36
        this.lang_name = 'Bosnian';
        break;
      case 'ca': // 41
        this.lang_name = 'Catalan';
        break;
      case 'cs': // 62
        this.lang_name = 'Czech';
        break;
      case 'cy': // 290
        this.lang_name = 'Welsh';
        break;
      case 'da': // 64
        this.lang_name = 'Danish';
        break;
      case 'de': // 88
        this.lang_name = 'German';
        break;
      case 'dv': // 66
        this.lang_name = 'Divehi';
        break;
      case 'el': // 89
        this.lang_name = 'Greek';
        break;
      case 'en': // 1
        this.lang_name = 'English';
        break;
      case 'es': // 247
        this.lang_name = 'Spanish';
        break;
      case 'et': // 73
        this.lang_name = 'Estonian';
        break;
      case 'eu': // 27
        this.lang_name = 'Basque';
        break;
      case 'fa': // 210
        this.lang_name = 'Persian';
        break;
      case 'fi': // 78
        this.lang_name = 'Finnish';
        break;
      case 'fr': // 79
        this.lang_name = 'French';
        break;
      case 'gl': // 85
        this.lang_name = 'Galician';
        break;
      case 'hr': // 61
        this.lang_name = 'Croatian';
        break;
      case 'hu': // 104
        this.lang_name = 'Hungarian';
        break;
      case 'hy': // 15
        this.lang_name = 'Armenian';
        break;
      case 'id': // 109
        this.lang_name = 'Indonesian';
        break;
      case 'is': // 105
        this.lang_name = 'Icelandic';
        break;
      case 'it': // 114
        this.lang_name = 'Italian';
        break;
      case 'ja': // 116
        this.lang_name = 'Japanese';
        break;
      case 'jv': // 117
        this.lang_name = 'Javanese';
        break;
      case 'ko': // 132
        this.lang_name = 'Korean';
        break;
      case 'ky': // 140
        this.lang_name = 'Kirghiz';
        break;
      case 'lt': // 152
        this.lang_name = 'Lithuanian';
        break;
      case 'lv': // 146
        this.lang_name = 'Latvian';
        break;
      case 'nl': // 69
        this.lang_name = 'Dutch';
        break;
      case 'no': // 195
        this.lang_name = 'Norwegian';
        break;
      case 'pl': // 211
        this.lang_name = 'Polish';
        break;
      case 'pt': // 212
        this.lang_name = 'Portuguese';
        break;
      case 'ro': // 220
        this.lang_name = 'Romanian';
        break;
      case 'rs': // 234
        this.lang_name = 'Serbian';
        break;
      case 'ru': // 223
        this.lang_name = 'Russian';
        break;
      case 'rw': // 128
        this.lang_name = 'Kinyarwanda';
        break;
      case 'si': //	240
        this.lang_name = 'Sinhala';
        break;
      case 'sk': //	242
        this.lang_name = 'Slovak';
        break;
      case 'sl': //	243
        this.lang_name = 'Slovenian';
        break;
      case 'sr': //	234
        this.lang_name = 'Serbian';
        break;
      case 'sv': // 252
        this.lang_name = 'Swedish';
        break;
      case 'th': //	265
        this.lang_name = 'Thai';
        break;
      case 'tr': // 276
        this.lang_name = 'Turkish';
        break;
      case 'uk': //	281
        this.lang_name = 'Ukrainian';
        break;
      case 'uz': //	284
        this.lang_name = 'Uzbek';
        break;
      case 'vi': //	287
        this.lang_name = 'Vietnamese';
        break;
      case 'zh-cn': // 51
        this.lang_name = 'Chinese - Simplified';
        break;
      case 'zh': // 51
        this.lang_name = 'Chinese - Simplified';
        break;
      case 'zh-tw': // 52
        this.lang_name = 'Chinese - Traditional';
        break;
      case 'ps': // 209
        this.lang_name = 'Pashto';
        break;
      case 'sq': // 8
        this.lang_name = 'Albanian';
        break;
      case 'be': // 29
        this.lang_name = 'Belarusian';
        break;
      case 'km': // 126
        this.lang_name = 'Khmer';
        break;
      case 'am': // 9
        this.lang_name = 'Amharic';
        break;
      case 'ur': // 282
        this.lang_name = 'Urdu';
        break;
      case 'ka': // 87
        this.lang_name = 'Georgian';
        break;
      case 'he': // 97
        this.lang_name = 'Hebrew';
        break;
      case 'kk': // 125
        this.lang_name = 'Kazakh';
        break;
      case 'sw': // 250
        this.lang_name = 'Swahili';
        break;
      case 'lo': // 144
        this.lang_name = 'Lao';
        break;
      case 'mk': // 160
        this.lang_name = 'Macedonian';
        break;
      case 'mn': // 180
        this.lang_name = 'Mongolian';
        break;
      case 'ne': // 189
        this.lang_name = 'Nepali';
        break;
      case 'ta': // 261
        this.lang_name = 'Tamil';
        break;
      case 'tg': // 259
        this.lang_name = 'Tajik';
        break;
      case 'tk': // 277
        this.lang_name = 'Turkmen';
        break;
      case 'my': // 39
        this.lang_name = 'Burmese';
        break;
      case 'ti': // 267
        this.lang_name = 'Tigrinya';
        break;
      case 'mt': // 167
        this.lang_name = 'Maltese';
        break;
      case 'sm': // 226
        this.lang_name = 'Samoan';
        break;
      default: {
        this.lang_name = 'English';
      }
    }

    return this.lang_name;
  }
}
